/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-07-31 14:01:30
 * @LastEditTime: 2020-10-08 17:55:17
 * @Description: 路由根目录
 */
import Vue from "vue";
import Router from "vue-router";

const Home = () => import("@/views/Home");
const CustomerPage = () => import("@/views/CustomerPage");
const CustomerAnalyzePage = () => import("@/views/CustomerPage/CustomerAnalyze");
const CustomerDetail = () => import("@/views/CustomerPage/CustomerDetail");
const SignupPage = () => import("@/views/LandingPage/Signup");
const SignupCompanyPage = () => import("@/views/LandingPage/SignupCompany");
const LandingPage = () => import("@/views/LandingPage");
const LoginPage = () => import("@/views/LandingPage/Login");
const UserManagementPage = () => import("@/views/UserManagementPage");
const RawMaterialPage = () => import('@/views/RawMaterialPage')
const MaterialSearchAndReplace = () => import('@/views/RecipePage/MaterialSearchAndReplace')
const FactoryPage = () => import('@/views/FactoryPage')
const SemiMaterialPage = () => import('@/views/SemiMaterialPage')
const SalesPage = () => import('@/views/SalesPage')
const EditSalesPlan = () => import('@/views/SalesPlanPage/EditSalesPlan')
const EditReceivePlan = () => import('@/views/SalesPlanPage/EditReceivePlan')
const SalesPlanPage = () => import('@/views/SalesPlanPage')
const ProductPage = () => import('@/views/ProductPage')
const SACPage = () => import('@/views/SACPage')
const SACCompanyPage = () => import('@/views/SACCompanyPage')
const SACDetail = () => import('@/views/SACPage/SACDetail')
const CompanyPage = () => import('@/views/CompanyPage')
const TankRental = () => import('@/views/TankRentalPage')
const SalesOrderPage = () => import('@/views/SalesOrderPage')
const VehiclePage = () => import('@/views/VehiclePage')
const SalesProdOrderPage = () => import('@/views/SalesProdOrderPage')
const UserSetting = () => import('@/views/UserSetting')
const InstrumentPanel = () => import('@/views/InstrumentPanel')
const SalesRecord = () => import('@/views/SalesRecord')
const TechnicalServicePage = () => import('@/views/TechnicalServicePage')
const CustomerDevelopPage = () => import('@/views/CustomerDevelopPage')
const ChangePassword = () => import('@/views/LandingPage/ChangePassword')
const CaclPurchasePage = () => import('@/views/CaclPurchasePage')
const CaclMLCostPage = () => import('@/views/CaclMLCostPage')
const CaclSalesCost = () => import('@/views/CaclSalesCost')
const RecipePage = () => import('@/views/RecipePage')
const SemiItemPage = () => import('@/views/SemiItemPage')
const CustomerPermissionsPage = () => import('@/views/CustomerPage/CustomerPermissions')
const CaclSalesCostAnalyze = () => import('@/views/CaclSalesCost/CaclSalesCostAnalyze')
const SalesContract = () => import('@/views/SalesContract')
const SemiContrastPage = () => import('@/views/CaclMLCostPage/SemiContrast')
const StorageTankPage = () => import('@/views/StorageTankPage')
const ReceivePage = () => import('@/views/ReceivePage')
const JDItemCodeCheckPage = () => import('@/views/JDItemCodeCheckPage')
const BankAccountPage = () => import('@/views/BankAccountPage')
const TaskPage = () => import('@/views/TaskPage')
const CalcCostPage = () => import('@/views/CalcCostPage')
const PaymentPage = () => import('@/views/PaymentPage')
const SupplierPage = () => import('@/views/SupplierPage')
const EntityPage = () => import('@/views/EntityPage')
const ImportFileProcessPage = () => import('@/views/ImportFileProcessPage')
const ReceiveChartPage = () => import('@/views/ReceiveChartPage')
const OutStoreStatPage = () => import('@/views/OutStoreStatPage')
const TechServiceStatPage = () => import('@/views/TechServiceStatPage')
const BillPage = () => import('@/views/BillPage')
const ImportARTablePage = () => import('@/views/ImportARTablePage')
const ImportCustomerQZTablePage = () => import('@/views/ImportCustomerQZTablePage')
const CustomerContactPage = () => import('@/views/CustomerContactPage')
const SalesPromoFeePage = () => import('@/views/SalesPromoFeePage')
const ReceiveTaskPage = () => import('@/views/ReceiveTaskPage')
const SalesOrderVolPag = () => import('@/views/SalesOrderVolPag')
const CustomerQzUpdateFormReview = () => import('@/views/CustomerQzUpdateFormReview')
const ReceiveTaskStatPage = () => import('@/views/ReceiveTaskStatPage')
const DuizhangdanPage = () => import('@/views/DuizhangdanPage')
const DuizhangdanListPage = () => import('@/views/DuizhangdanListPage')
const SalesOrderProfitPage = () => import('@/views/SalesOrderProfitPage')
const SalesOrderTablePage = () => import('@/views/SalesOrderTablePage')

Vue.use(Router);
// 获取原型对象上push函数
const originalPush = Router.prototype.push
// 修改原型对象中push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routeList = [{
    path: "task",
    name: "task",
    component: TaskPage,
    meta: {
      namezh: "任务"
    },
  },
  {
    path: "receive_task_stat",
    name: "receive_task_stat",
    component: ReceiveTaskStatPage,
    meta: {
      namezh: "回款任务统计"
    },
  },
  {
    path: "salesRecord",
    name: "salesRecord",
    component: SalesRecord,
    meta: {
      namezh: "销售记录"
    },
  },
  {
    path: "customer",
    name: "customer",
    component: CustomerPage,
    meta: {
      namezh: "客户"
    },
    children: [{
      path: "customer_detail",
      name: 'customerDetail',
      component: CustomerDetail,
      meta: {
        namezh: "客户详细"
      }
    }],
  },
  {
    path: "customer_analyze",
    name: "customerAnalyze",
    component: CustomerAnalyzePage,
    meta: {
      namezh: "客户分析"
    },
  },
  {
    path: "customerPermissions",
    name: "customerPermissions",
    component: CustomerPermissionsPage,
    meta: {
      namezh: "客户权限管理"
    },
  },
  {
    path: "receive",
    name: "receive",
    component: ReceivePage,
    meta: {
      namezh: "回款记录"
    },
  },
  {
    path: "receive_chart",
    name: "receive_chart",
    component: ReceiveChartPage,
    meta: {
      namezh: "回款统计"
    },
  },
  {
    path: "bill",
    name: "bill",
    component: BillPage,
    meta: {
      namezh: "票据"
    },
  },
  {
    path: "instrumentPanel",
    name: "instrumentPanel",
    component: InstrumentPanel,
    meta: {
      namezh: "仪表盘"
    }
  },
  {
    path: 'usermanagement',
    name: 'usermanagement',
    component: UserManagementPage,
    meta: {
      namezh: "用户和权限"
    }
  },
  {
    path: 'raw_material',
    name: 'raw_material',
    component: RawMaterialPage,
    meta: {
      namezh: "材料管理"
    }
  },
  {
    path: 'materialSearchAndReplace',
    name: 'materialSearchAndReplace',
    component: MaterialSearchAndReplace,
    meta: {
      namezh: "原材料搜查与替换"
    }
  },
  {
    path: 'semi_material',
    name: 'semi_material',
    component: SemiMaterialPage,
    meta: {
      namezh: "母液管理"
    }
  },
  {
    path: 'semi_Item',
    name: 'semi_Item',
    component: SemiItemPage,
    meta: {
      namezh: "母液管理"
    }
  },
  {
    path: 'product',
    name: 'product',
    component: ProductPage,
    meta: {
      namezh: "产品管理"
    }
  },
  {
    path: 'caclPurchase',
    name: 'caclPurchase',
    component: CaclPurchasePage,
    meta: {
      namezh: "材料成本"
    }
  },
  {
    path: 'caclMLCost',
    name: 'caclMLCost',
    component: CaclMLCostPage,
    meta: {
      namezh: "母液成本"
    }
  },
  {
    path: 'semiContrast',
    name: 'semiContrast',
    component: SemiContrastPage,
    meta: {
      namezh: "母液比较"
    }
  },
  {
    path: 'caclSalesCost',
    name: 'caclSalesCost',
    component: CaclSalesCost,
    meta: {
      namezh: "客户成本"
    },
  },
  {
    path: 'calcCost',
    name: 'calcCost',
    component: CalcCostPage,
    meta: {
      namezh: "成本核算"
    },
  },
  {
    path: 'caclSalesCostAnalyze',
    name: 'caclSalesCostAnalyze',
    component: CaclSalesCostAnalyze,
    meta: {
      namezh: "客户成本历史分析"
    }
  },
  {
    path: 'sales',
    name: 'sales',
    component: SalesPage,
    meta: {
      namezh: "销售项目"
    }
  },
  {
    path: 'jd_item_code_check',
    name: 'JDItemCodeCheck',
    component: JDItemCodeCheckPage,
    meta: {
      namezh: "金蝶云物料对比"
    }
  },
  {
    path: 'salesPlan',
    name: 'salesPlan',
    component: SalesPlanPage,
    children: [{
        path: "edit_salesPlan",
        name: 'salesPlanVol',
        component: EditSalesPlan,
        meta: {
          namezh: "销量计划"
        }
      },
      {
        path: "edit_receivePlan",
        name: 'salesPlanReceive',
        component: EditReceivePlan,
        meta: {
          namezh: "回款计划"
        }
      }
    ],
    meta: {
      namezh: "销售计划",
    }
  },
  {
    path: 'recipe',
    name: 'recipe',
    component: RecipePage,
    meta: {
      namezh: "配方管理"
    }
  },
  {
    path: 'tech_service',
    name: 'tech_service',
    component: TechnicalServicePage,
    meta: {
      namezh: "技术服务"
    }
  },
  {
    path: 'customer_develop',
    name: 'customer_develop',
    component: CustomerDevelopPage,
    meta: {
      namezh: "客户开发"
    }
  },
  {
    path: 'factory',
    name: 'factory',
    component: FactoryPage,
    meta: {
      namezh: "工厂"
    }
  },
  // {
  //   path: 'sac/:id',
  //   name: 'sac',
  //   component: SACDetail,
  //   meta: { namezh: "复配中心" },
  // },
  // {
  //   path: 'sac',
  //   name: 'sac',
  //   component: SACPage,
  //   meta: { namezh: "智能复配中心" },
  // },
  // {
  //   path: 'sac_company',
  //   name: 'sac_company',
  //   component: SACCompanyPage,
  //   meta: { namezh: "智能复配中心-公司" },
  // },
  {
    path: 'company',
    name: 'company',
    component: CompanyPage,
    meta: {
      namezh: "公司"
    },
  },
  {
    path: 'storageTank',
    name: 'storageTank',
    component: StorageTankPage,
    meta: {
      namezh: "储罐列表"
    },
  },
  {
    path: 'tankRental',
    name: 'tankRental',
    component: TankRental,
    meta: {
      namezh: "储罐借用"
    },
  },
  {
    path: 'sales_order',
    name: 'sales_order',
    component: SalesOrderPage,
    meta: {
      namezh: "销售订单"
    }
  },
  {
    path: 'sales_contract',
    name: 'sales_contract',
    component: SalesContract,
    meta: {
      namezh: "销售合同"
    }
  },
  {
    path: 'vehicle',
    name: 'vehicle',
    component: VehiclePage,
    meta: {
      namezh: "车辆信息"
    }
  },
  {
    path: 'sales_prod_order',
    name: 'sales_prod_order',
    component: SalesProdOrderPage,
    meta: {
      namezh: "销售生产订单"
    }
  },
  {
    path: 'bank_account',
    name: 'bankAccount',
    component: BankAccountPage,
    meta: {
      namezh: "收款账号"
    }
  },
  {
    path: 'payment',
    name: 'payment',
    component: PaymentPage,
    meta: {
      namezh: "付款记录"
    }
  },
  {
    path: 'supplier',
    name: 'supplier',
    component: SupplierPage,
    meta: {
      namezh: "供应商"
    }
  },
  {
    path: 'entity',
    name: 'entity',
    component: EntityPage,
    meta: {
      namezh: "机构"
    }
  },
  {
    path: 'importFileProcess',
    name: 'importFileProcess',
    component: ImportFileProcessPage,
    meta: {
      namezh: "出库单"
    }
  },
  {
    path: 'outStoreStat',
    name: 'outStoreStat',
    component: OutStoreStatPage,
    meta: {
      namezh: "出库单统计"
    }
  },
  {
    path: 'importARTable',
    name: 'importARTable',
    component: ImportARTablePage,
    meta: {
      namezh: "账龄"
    }
  },
  {
    path: 'tech_service_stat',
    name: 'tech_service_stat',
    component: TechServiceStatPage,
    meta: {
      namezh: "技服统计"
    }
  },
  {
    path: 'import_customer_qz_table',
    name: 'import_customer_qz_table',
    component: ImportCustomerQZTablePage,
    meta: {
      namezh: "权责表"
    }
  },
  {
    path: 'customer_qz_review',
    name: 'customer_qz_review',
    component: CustomerQzUpdateFormReview,
    meta: {
      namezh: "权责审核"
    }
  },
  {
    path: 'customer_contact',
    name: 'customer_contact',
    component: CustomerContactPage,
    meta: {
      namezh: "联系人"
    }
  },
  {
    path: 'sales_promo_fee',
    name: 'sales_promo_fee',
    component: SalesPromoFeePage,
    meta: {
      namezh: "业务费"
    }
  },
  {
    path: 'receive_task',
    name: 'receive_task',
    component: ReceiveTaskPage,
    meta: {
      namezh: "回款任务"
    }
  },
  {
    path: 'sales_order_vol',
    name: 'sales_order_vol',
    component: SalesOrderVolPag,
    meta: {
      namezh: "销量统计"
    }
  },
  {
    path: 'duizhangdan_list',
    name: 'duizhangdan_list',
    component: DuizhangdanListPage,
    meta: {
      namezh: "对账单列表"
    }
  },
  {
    path: 'sales_order_profit',
    name: 'sales_order_profit',
    component: SalesOrderProfitPage,
    meta: {
      namezh: "客户利润"
    }
  },
  {
    path: 'sales_order_table',
    name: 'sales_order_table',
    component: SalesOrderTablePage,
    meta: {
      namezh: "销售订单列表"
    }
  },
];

const router = new Router({
  mode: "history",
  routes: [{
      path: "/home",
      name: "home",
      component: Home,
      children: routeList,
    },
    {
      path: "/",
      name: "landing",
      component: LandingPage,
      meta: {
        namezh: "界面"
      },
    },
    {
      path: "/login",
      name: "login",
      component: LoginPage,
      meta: {
        namezh: "登录"
      },
    },
    {
      path: "/signup",
      name: "signup",
      component: SignupPage,
      meta: {
        namezh: "注册"
      },
    },
    {
      path: "/signup_company",
      name: "signup_company",
      component: SignupCompanyPage,
      meta: {
        namezh: "注册公司"
      },
    },
    {
      path: "/changePassword",
      name: "changePassword",
      component: ChangePassword,
      meta: {
        namezh: "重置密码"
      },
    },

    {
      path: "*",
      redirect: "/404",
      name: "404",
      component: LandingPage,
      hidden: true,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/login", "/signup", "/"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("token");

  if (authRequired && !loggedIn) {
    return next("/login");
  }
  next();
});

export default router;